import React from 'react';
import { Helmet } from 'react-helmet-async';

const itemData = [
  { img: 'https://img1.wsimg.com/isteam/ip/86403bdc-5b06-4791-9369-bce7397fffaa/naw32_0b-600x432.jpg', title: 'Naw32' },
  { img: 'https://img1.wsimg.com/isteam/ip/86403bdc-5b06-4791-9369-bce7397fffaa/supermoto-guy-racer-ktm-350-sx-f-2020-8.jpg', title: 'Supermoto Racer' },
  { img: 'https://img1.wsimg.com/isteam/ip/86403bdc-5b06-4791-9369-bce7397fffaa/DSC00884.jpg', title: 'DSC00884' },
  { img: 'https://motomagazine.co.il/wp-content/uploads/2019/09/naw32_012.jpg', title: 'Moto Magazine 1' },
  { img: 'http://motomagazine.co.il/wp-content/uploads/2019/09/naw32_0b.jpg', title: 'Moto Magazine 2' },
  { img: 'http://motomagazine.co.il/wp-content/uploads/2020/09/supermoto-guy-racer-ktm-350-sx-f-2020-6.jpg', title: 'Moto Magazine 3' },
  { img: 'http://motomagazine.co.il/wp-content/uploads/2020/09/supermoto-guy-racer-ktm-350-sx-f-2020-2.jpg', title: 'Moto Magazine 4' },
  { img: 'http://motomagazine.co.il/wp-content/uploads/2020/09/supermoto-guy-racer-ktm-350-sx-f-2020-3.jpg', title: 'Moto Magazine 5' },
  { img: 'http://motomagazine.co.il/wp-content/uploads/2020/09/supermoto-guy-racer-ktm-350-sx-f-2020-by-benny-doutsh-394.jpg', title: 'Moto Magazine 6' },
  { img: 'https://live.staticflickr.com/7863/46479099382_2e133cee87_z.jpg', title: 'Flickr 1' },
  { img: 'https://live.staticflickr.com/7896/31590816577_baec9d9e15_z.jpg', title: 'Flickr 2' },
  { img: 'https://live.staticflickr.com/7805/32657810608_e489526a55_z.jpg', title: 'Flickr 3' },
  { img: 'https://live.staticflickr.com/4873/32657812428_36ebcb7b04.jpg', title: 'Flickr 4' },
];

const landscapeImages = [
  'photographer_103357315_10216643554058409_7374787626174772693_n.jpg',
  'photographer_109691655_10216643553498395_3145580228331269477_n.jpg',
  'photographer_120799557_10217202743357792_4735370277101617501_n.jpg',
  'photographer_120802887_10217202744677825_1361541131478115110_n.jpg',
  'photographer_120803765_10217202742037759_6056297210584089188_n.jpg',
  'photographer_120820560_10217202740717726_4210432735105338357_n.jpg',
  'photographer_120827428_10217202744077810_6593479431245337885_n.jpg',
  'photographer_120837761_10217202743037784_7137567322890665822_n.jpg',
  'photographer_165774678_10218201153957433_981281129117469634_n.jpg',
  'photographer_165780213_10218201154717452_2704727075203852012_n.jpg',
  'photographer_165786659_10218201152237390_136266643904805529_n.jpg',
  'photographer_166722294_10218206655614971_1578327217357928112_n.jpg',
  'photographer_465010479_27282212631421982_3028786768866714409_n.jpg',
  'photographer_470854267_10225491520652044_8523036369103777777_n.jpg',
  'photographer_471163381_10225484818124485_3000754238725428461_n.jpg',
  'photographer_486251348_10226150349162345_2788985539743379333_n.jpg',
  'photographer_57032229_10213428469043293_2650873417321938944_n.jpg',
  'photographer_70798614_10214419531299230_8261940373534801920_n.jpg',
  'photographer122307602_10217298518912121_4721843679224118010_n.jpg',
];

const portraitImages = [
  'photographer_111009805_10216690485791673_5919312240910563075_n.jpg',
  'photographer_116321074_10216722897001933_3252645984390826445_n.jpg',
  'photographer_120809592_10217202746557872_6335790939661077752_n.jpg',
  'photographer_166373529_10218206655974980_2078032152770049554_n.jpg',
];

const Journalism = () => {
  return (
    <div className="container">
      <Helmet>
        <title>Ariel Rotem | Aviation Journalist & Photographer</title>
        <meta name="description" content="Ariel Rotem is a credentialed aviation journalist and professional photographer covering global motorsports, aviation, and extreme sports." />
      </Helmet>
      <div className="mb-4">
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '2.5rem' }}>$ cat aviation_journalist.log</h1>
      </div>

      <div className="terminal-card">
        <p className="mono">
          My journey into photography began in high school, blending technical engineering with artistic pursuit. It extended to sports photography, capturing professional athletes and culminating in working as an official pit photographer at the Supermoto of Nations (World Cup finals).
        </p>
        <p className="mono mt-1">
          I hold active journalist credentials focusing heavily on aviation and motorsports across the globe.
        </p>
      </div>

      <div className="grid grid-cols-2 mt-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        <div className="terminal-card">
          <h3 className="mb-2" style={{ color: 'var(--accent-primary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
            &gt; AUTH_CREDENTIALS :: IAPP
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
            <img 
              src="https://www.ia-pp.com/files/passbilder/th_tszetvnj9ziiyewbcmon.png" 
              alt="Ariel Rotem Profile"
              style={{ width: '120px', height: '120px', borderRadius: '50%', border: '2px solid var(--accent-secondary)' }}
            />
            <div className="mono text-secondary">
              <h4 style={{ color: 'var(--text-primary)' }}>Ariel Rotem</h4>
              <p>Aviation Journalist / Poyke.inc</p>
              <p>IAPP ID: <a href="https://www.ia-pp.com/profil/ariel-rotem-40111" target="_blank" rel="noopener noreferrer">US/8-l-40111</a></p>
              <p>Exp: 2026-12-31</p>
            </div>
          </div>
        </div>

        <div className="terminal-card">
          <h3 className="mb-2" style={{ color: 'var(--accent-tertiary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
            &gt; COMMUNITY_PROFILES
          </h3>
          <ul className="mono text-secondary" style={{ paddingLeft: '20px', fontSize: '0.85rem' }}>
            <li className="mb-2">
              <a href="https://www.localguides-ranking.com/profile/17680/" target="_blank" rel="noopener noreferrer">Google Local Guide (Level 8)</a>
            </li>
            <li className="mb-2">
              <a href="https://www.flickr.com/photos/arielrotem/" target="_blank" rel="noopener noreferrer">Flickr Photography Cluster</a>
            </li>
            <li className="mb-2">
              <a href="https://www.facebook.com/motorid3r/" target="_blank" rel="noopener noreferrer">Facebook Motorsports Page</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="terminal-card mt-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-secondary)', borderBottom: '1px dashed var(--text-secondary)', paddingBottom: '10px' }}>
          &gt; PRESS_PUBLICATIONS.log
        </h3>
        <ul className="mono text-secondary" style={{ paddingLeft: '20px', fontSize: '0.85rem' }}>
          <li className="mb-1"><a href="https://motomagazine.co.il/motor/יומן-מרוצים-גיא-יצחק-לריאה-שנת-עשרים-ע/" target="_blank" rel="noopener noreferrer">יומן מרוצים: גיא יצחק לריאה שנת עשרים ע (Moto Magazine)</a></li>
          <li className="mb-1"><a href="https://kruvi.net/2019/09/25/ישראלים-בסופרמוטו-האומות-2019/" target="_blank" rel="noopener noreferrer">ישראלים בסופרמוטו האומות 2019 (Kruvi.net)</a></li>
          <li className="mb-1"><a href="https://motomagazine.co.il/motor/סופרמוטו-האומות-הישג-מכובד-לנ-בחרת-ישר/" target="_blank" rel="noopener noreferrer">סופרמוטו האומות: הישג מכובד לנבחרת ישר (Moto Magazine)</a></li>
          <li className="mb-1"><a href="https://motomagazine.co.il/motor/נבחרת-ישראל-במרוץ-האומות-בסופרמוטו/" target="_blank" rel="noopener noreferrer">נבחרת ישראל במרוץ האומות בסופרמוטו (Moto Magazine)</a></li>
          <li className="mb-3"><a href="https://www.calameo.com/read/004663782e00fb98a4248" target="_blank" rel="noopener noreferrer">Moto Magazine print issue October 2019 (Calameo)</a></li>
          
          <li className="text-primary mt-2 mb-1">[ IN_THE_NEWS ]</li>
          <li className="mb-1"><a href="https://www.news4jax.com/news/local/2020/12/07/coast-to-coast-man-attempts-to-break-world-paramotor-record/" target="_blank" rel="noopener noreferrer">Coast-to-coast man attempts to break world paramotor record (News4Jax)</a></li>
          <li className="mb-1"><a href="https://localnewsmatters.org/2020/12/08/walnut-creek-pilot-on-quest-to-become-first-to-fly-cross-country-by-paramotor/" target="_blank" rel="noopener noreferrer">Walnut Creek pilot on quest to become first to fly cross-country by paramotor (Local News Matters)</a></li>
          <li className="mb-1"><a href="https://pleasantonweekly.com/news/2020/12/07/local-paramotor-pilot-in-midst-of-transcontinental-flight" target="_blank" rel="noopener noreferrer">Local paramotor pilot in midst of transcontinental flight (Pleasanton Weekly)</a></li>
        </ul>
      </div>

      <div className="terminal-card mt-4">
        <h3 className="mb-2" style={{ color: 'var(--accent-primary)' }}>&gt; RENDER_GALLERY</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
          {itemData.map((item, idx) => (
            <img key={idx} src={item.img} alt={`Ariel Rotem Photography: ${item.title}`} style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
          {landscapeImages.map((img, idx) => (
            <img key={`l_${idx}`} src={`/PhotosForWebsite/${img}`} alt="Ariel Rotem aviation journalism and sports photography" style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
          {portraitImages.map((img, idx) => (
            <img key={`p_${idx}`} src={`/PhotosForWebsite/${img}`} alt="Ariel Rotem official pit photographer capture" style={{ width: '100%', aspectRatio: '3/4', objectFit: 'cover', border: '1px solid var(--text-secondary)' }} />
          ))}
        </div>
      </div>

    </div>
  );
};

export default Journalism;
